import { action } from 'typesafe-actions';
import { IProfile } from '@kattana-io/common';

const entity = 'features';

const SET_PRICING_PLAN = `${entity}/SET_PRICING_PLAN`;
const RESET_PRICING_PLAN = `${entity}/RESET_PRICING_PLAN`;
const START_POLLING_PAYMENT = `${entity}/START_POLLING_PAYMENT`;
const STOP_POLLING_PAYMENT = `${entity}/STOP_POLLING_PAYMENT`;

const actionSetPricingPlan = (plan: IProfile) => action(SET_PRICING_PLAN, plan);
const actionResetPricingPlan = () => action(RESET_PRICING_PLAN);
const actionStartPollingPayment = () => action(START_POLLING_PAYMENT);
const actionStopPollingPayment = () => action(STOP_POLLING_PAYMENT);

export {
  SET_PRICING_PLAN,
  RESET_PRICING_PLAN,
  START_POLLING_PAYMENT,
  STOP_POLLING_PAYMENT,
  actionSetPricingPlan,
  actionResetPricingPlan,
  actionStartPollingPayment,
  actionStopPollingPayment,
};
